<ag-grid-row-count [gridApi]="gridApi" [gridTracker]="gridTracker" [gridOptions]="gridOptions" prefix="" suffix=""></ag-grid-row-count>
<ws-ag-grid-angular [gridOptions]="gridOptions"
                    (gridReady)="onAgGridReady($event)"
                    [exportOptions]="exportOptions"
                    [gridId]="gridId">
</ws-ag-grid-angular>
